// src/features/feeds/useFeed.ts

import { useQuery } from '@tanstack/react-query';
import { FeedApi } from './FeedApi';
import { FEED_QUERY_KEYS } from '@/lib/constants/feed';
import { useAuth } from '@/features/auth/hooks/useAuth';

/**
 * Fetch single feed by selecting from the feeds list cache.
 * The backend has no dedicated single-feed GET endpoint — legacy code
 * loaded all feeds and looked up by ID in memory. We mirror that by
 * sharing the list query key so the data stays in sync with useFeeds.
 */
export function useFeed(feedId: number) {
  const { selectedCId } = useAuth();

  return useQuery({
    queryKey: FEED_QUERY_KEYS.list(selectedCId ?? 0),
    queryFn: async () => {
      const result = await FeedApi.getFeeds(selectedCId!);
      return result.data;
    },
    enabled: selectedCId != null && feedId > 0,
    staleTime: 2 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    select: (feeds) => feeds.find((f) => f.feedId === feedId),
  });
}
